/* global mixpanel */

/**
 *
 * @param {array} pinSettings
 */
export function savePin ({pinSettings}) {
  const data = {}
  pinSettings.forEach((pin) => {
    data[pin.sub_menu] = pin.pin_required
  })
  mixpanel.track('Configure Permission', data)
}



// WEBPACK FOOTER //
// ./app/mixpanel/employees/pin.js